import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import DefaultClusterMarker from "@irati-web/geolocation/src/components/GeoMap/ClusterMarker"
import {Label4} from "@irati/ui/src/Labels/"
import {FormattedMessage} from "@irati/utils/lang"

const StyledMarker = styled(DefaultClusterMarker)`
  flex-direction: column;
`

const ClusterMarker = ({children}) => {
  return (
    <StyledMarker>
      {children}
      <Label4 bold>
        <FormattedMessage id="search.components.searchAllByLocation.clusterMarker.label" />
      </Label4>
    </StyledMarker>
  )
}

ClusterMarker.propTypes = {
  children: PropTypes.any.isRequired
}

export default ClusterMarker
